export default __webpack_public_path__ + "static/myles-8bb886a90be180fe4de76369284ed89f.jpg";